// extracted by css-extract-rspack-plugin
export default {"footer":"dsCom","left":"jYpwZ","buttonGroup":"Kh86r","button":"G0fLe","right":"tEisr"};